<app-loader [Parent]="this"></app-loader>
<div [formGroup]="Form" *ngIf="FormLoaded">
  <app-pageheader [Parent]="this">
    <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()"></app-form-save-button>
    @if (!ModelIsNew) {
      <app-form-delete-button [Parent]="this" [Form]="Form" [ModelId]="ModelId" [Model]="Model"
        DeleteUrl="payments/transactionbreakdown/fees/" DeleteNavLink="/revenue/transactionbreakdown" Title="Fee" NameProperty="DisplayName">
      </app-form-delete-button>
    }
  </app-pageheader>
  <div class="columns">
    <div class="column is-6">
      <article class="panel">
        <p class="panel-heading">Fee</p>
        <div class="panel-block is-block">
          <app-field Label="Display Name">
            <div class="control">
              <input formControlName="DisplayName" class="input" type="text" placeholder="Shown on the breakdown line, e.g. City Surcharge" />
              <app-validator [For]="Form.get('DisplayName')"></app-validator>
            </div>
          </app-field>
          <app-field Label="Fee Type">
            <div class="control select is-fullwidth">
              <select formControlName="TransactionFeeTypeId">
                @for (feeType of FeeTypes ?? []; track feeType.Id) {
                  <option [ngValue]="feeType.Id">{{feeType.Name}}</option>
                }
              </select>
              <app-validator [For]="Form.get('TransactionFeeTypeId')"></app-validator>
            </div>
          </app-field>
          <app-field [Label]="SelectedFeeType()?.ValueKind == 1 ? 'Flat Amount' : 'Percentage (15 = 15%)'">
            <div class="control">
              <input formControlName="Value" class="input" type="number" min="0" step="0.01" />
              <app-validator [For]="Form.get('Value')"></app-validator>
            </div>
          </app-field>
          <app-field Label="Active">
            <p class="control">
              <app-toggleswitch formControlName="Active"></app-toggleswitch>
            </p>
          </app-field>
        </div>
      </article>
    </div>
  </div>
</div>
